import React from 'react';

const LeaderboardMoversBasicIcon = ({ stateIcon }) => {
    return (
        <div className={`leaderboard__cell-icon-wrapper ${stateIcon}`}>
            <svg className="leaderboard__cell-icon icon" width="9" height="6" focusable="false">
                <use xlinkHref="#icon-triangle"></use>
            </svg>
        </div>
    );
};

export default LeaderboardMoversBasicIcon;
